import React from "react";

const Button = ({ type, className, children, onClick, style,...rest }) => {
  return (
    <>
      <button type={type} onClick={onClick} className={className} {...rest} style={style}>
        {children}
      </button>
    </>
  );
};

export default Button;
